module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jack")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Jack Farrar, with only his faithful dog for company, was enjoying a drink on the deck of his sloop, his current crew member having taken off for a bout of shopping in Saint-Tropez.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jack met a lot of women on his travels, like for instance Sugar, the blonde currently crewing his boat: good-looking girls ready for fun and with no demands because Jack certainly wasn’t the marrying kind. And anyhow what woman in her right mind would want to spend a year in a boat circumnavigating the globe, battling storms and eating out of cans and having to wash her hair in salt water for weeks on end? None, so far as he knew. And certainly not one he could have spent that kind of time alone with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In fact, the times spent alone on this little sloop with only his dog for company were quite simply the best. Nothing could compare with those quiet moments, with just the stars overhead and the wind tugging the sails. Just him and the dog, the ink-blue water, and solitude. They were the highlights of his life. As, in another sense, were the storms he battled on the longer voyages, steering the bigger sloop he owned, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In a Minute,")]), _vm._v(" through towering waves that threatened to capsize them while the wind tossed them around like dandelion fluff. His crew tackled the elements along with him while the mutt cowered in the tiny salon, whining and strapped to a flotation device, just in case. And Jack also strapped himself to the wheel, just in case. Then the adrenaline would shoot through his veins, powerful as hot rum, and his triumph when they overcame the elements was, he thought, the peak of a man’s experience.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For Jack, there was nothing to touch that feeling, not even sex, though he was a sensual man. Or perhaps it was just that he hadn’t allowed any women into his life to share that deeper, all-consuming emotion that happens when love is added to the sexual equation. He had yet to find a woman who could give him the ultimate sensation he got from battling the elements alone on the sloop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was a loner, a nomad, a roamer, at home in the fishing ports of the world. He loved that life and he wasn’t about to give it up for any woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, on the long-haul trips on the fifty-footer, Jack wasn’t accompanied by any flighty women. Then his crew consisted of six men, one of whom was his good friend, the Mexican Carlos Ablantes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d first made Carlos’s acquaintance in Cabo San Lucas, a little town on the Baja Peninsula, where he’d gone fishing for marlin and dorado. It was November and the weather had turned rough, with water too cold for the big fish. But Carlos had been born and raised in Cabo and he knew his stuff. He was a true man of the sea, just the way Jack was. Carlos had taken him out on his boat; they’d spent a couple of nights out there together on the Sea of Cortez, reeling in only a lone dorado and getting to know one another, the way men do: few words spoke volumes; they knew who they were and that they liked each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Later, Carlos had come north for a spell, and he’d just stayed on. He worked at the boatyard, sailed with Jack on weekends, and crewed for him on his long trips, but every few months Carlos would return to Cabo, lured back like the marlin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Carlos was pretty good in the galley too. He cooked up a mean shrimp dish, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fajitas de camarones,")]), _vm._v(" and mixed the best margarita in the world, with Hornitos tequila, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limones,")]), _vm._v(" ice, and salt. Soon he and the rest of the crew would be joining Jack, here in the Med, and they’d set off in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In a Minute")]), _vm._v(" on another of their long voyages, to South Africa this time, heading for Capetown where the surfing was good, the women beautiful, and the wine just fine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Baja was where Jack had also met Luisa, the one woman he’d really loved. Lovely Luisa—hair like black satin, eyes like green jewels, and skin like bronze velvet. She’d loved him for all of three months, and he’d loved her about the same length of time. But passion can play havoc with a sailor’s schedule if he lets it, and Jack wasn’t about to do so. He was tough when it came to women. He valued his friendships and his sailing, in that order. Give him his boat, his friends, and his dog and he was a happy man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Life was pretty good. He had made enough money to keep him in the style he enjoyed, plus a little extra. When he wasn’t roaming the seas, he had a boatyard in Newport and that kept him pretty busy. He built racing yachts there, far sleeker and more expensive than his own. But this little old sloop was his favorite.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thought about the woman who’d caught him naked in the telescope earlier tonight. There was something interesting about her. Something about the long untidy sweep of taffy-colored hair, the lift of her cheekbones, the soft, full mouth, and the stunned look in her big brown eyes when they had met his in the binoculars. He grinned, just thinking about her shock at being caught peeking at him naked, and the way she looked in her too-tight T-shirt and odd pants.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He also liked the look of the small pink hotel, perched above the rocks amid a bower of tamarind and silvery olives. Even without binoculars, he could see the luxurious purple-pink tumble of bougainvillea and the candlelight flickering on the dining terrace. Lamps lit in the rooms behind cast an inviting amber glow, and the crackle of the still-lively "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cigales")]), _vm._v(" floated across the water, along with some music. Could that really be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barry White")]), _vm._v("? He grinned, thinking about the shocked taffy-haired woman. Maybe there was more to her than had met his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Either way, he was getting hungry and she was obviously running a restaurant. He might as well kill two birds with one stone, meet the woman and find out if she was as sexy as her mouth and the Barry White implied, and at the same time have a decent meal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t bother to change, just raked his hands through his disheveled brown hair, hitched up his baggy shorts, pulled on a white T-shirt and his old Tod’s driving shoes, the most comfortable shoes he’d ever owned and with which he would never part, despite their age and shabbiness. The shaggy black dog he’d rescued from the pound and certain death some years ago pranced at his side, eager to go wherever Jack led him. He’d named the unruly mutt Bad Dog, because he had never learned how to behave in civilized company. And then, because he loved Bad Dog as much as his boat, he’d named the sloop after the mutt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, old buddy,” he said, stooping to caress Bad Dog’s head, “but the other diners wouldn’t appreciate your finer qualities, especially when you attempt to steal the food from their plates.” He grinned. Bad Dog was a street hound, a scavenger of the highest order. Fancy joints with candlelight and good wine were definitely not for him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put food into Bad Dog’s bowl, made sure he had fresh water, gave him a new chew bone, then climbed into the dinghy, unhitched the line and started up the small outboard. Bad Dog hung his head over the side, gazing piteously down at him. He hated being left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Back soon, old buddy,” Jack called, as he slid over the smooth dark blue water toward the tiny wooden jetty sticking out into the Hotel Riviera’s cove. But what he was really thinking about was the look on Miss Taffy Hair’s face when she saw him again. In the flesh.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d77534be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312308094_ch05.vue
// module id = 81
// module chunks = 0